'use strict';

// This class attempts to centralize some functionality for the insights widgets.
// Add to it as you're able!

angular.module('MW.InsDashboard.InsightsDataMaps', [])
.service('InsightsDataMaps', [ '$timeout', function ( $timeout) {

    var serviceObj = {};

    var datamapDateVolume = function(dataRecord){
        var result = {x:dataRecord['date'],y:dataRecord['volume']};
        return result;
    };
    serviceObj.datamapDateVolume = datamapDateVolume;

    var datamapDateSentiment = function(dataRecord){
        var sentiment = {
            p:dataRecord['volume'].p,
            v:dataRecord['volume'].v,
            n:dataRecord['volume'].n
        };
        var result = {x:dataRecord['date'],y:sentiment};
        return result;
    };
    serviceObj.datamapDateSentiment = datamapDateSentiment;

    var datamapDateAverage = function(dataRecord){
        var result = {x:dataRecord['date'],y:dataRecord['average']};
        return result;
    };
    serviceObj.datamapDateAverage = datamapDateAverage;

    var datamapCountryVolume = function(dataRecord){
        var result = {x:dataRecord['country'],y:dataRecord['volume']};
        return result;
    };
    serviceObj.datamapCountryVolume = datamapCountryVolume;

    var datamapLanguageVolume = function(dataRecord){
        var result = {x:dataRecord['language'],y:dataRecord['volume']};
        return result;
    };
    serviceObj.datamapLanguageVolume = datamapLanguageVolume;

    var datamapSourceVolume = function(dataRecord){

        var result = {x:dataRecord['source'],y:dataRecord['volume'],z:dataRecord['sourceId']};
        return result;
    };
    serviceObj.datamapSourceVolume = datamapSourceVolume;

   var datamapEntityVolume = function(dataRecord){
        var result = {x:dataRecord['entity'],y:dataRecord['volume']};
        return result;
    };
    serviceObj.datamapEntityVolume = datamapEntityVolume;

    var datamapPosterVolume = function(dataRecord){
        var result = {x:dataRecord['poster'],y:dataRecord['volume']};
        return result;
    };
    serviceObj.datamapPosterVolume = datamapPosterVolume;

    var datamapKeyphraseVolume = function(dataRecord){

        var result = {x:dataRecord['keyphrase'],y:dataRecord['volume']};
        return result;
    };
    serviceObj.datamapKeyphraseVolume = datamapKeyphraseVolume;

    return serviceObj;

}]);
